/**
 * Cache and stale time constants for React Query
 * These values determine how long data is considered fresh before refetching
 */

export const STALE_TIME_30_SECONDS = 30_000;
export const STALE_TIME_1_MINUTE = 60_000;
export const STALE_TIME_5_MINUTES = 300_000;
export const STALE_TIME_1_HOUR = 3_600_000;
export const STALE_TIME_24_HOURS = 86_400_000;

// Polling intervals
export const POLL_INTERVAL_15_SECONDS = 15_000;
export const POLL_INTERVAL_20_SECONDS = 20_000;
export const POLL_INTERVAL_30_SECONDS = 30_000;
export const POLL_INTERVAL_60_SECONDS = 60_000;
